import React from "react"
import styled from "styled-components"
import Button, { ButtonProps } from "@material-ui/core/Button"
import { Typography } from "@material-ui/core"
import { bps } from "theme"

type Props = {
  title: string
  link?: string
} & ButtonProps

const StyledButton = styled(Button)`
  height: 48px !important;
  padding: 12px 20px !important;
  border-radius: 32px !important;
  text-transform: uppercase !important;
  color: #fff !important;
  background: #4dc11a 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 5px 20px #4dc11a66 !important;
  :hover {
    background: #4dc11a 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 5px 20px #4dc11a66 !important;
  }
`
const StyledInviteButton = styled(Button)`
  height: 48px !important;
  padding: 8px 28px !important;
  border-radius: 32px !important;
  text-transform: uppercase !important;
  color: #136d49 !important;
  font-weight: 700 !important;
  background: #ffffff 0% 0% no-repeat padding-box !important;
  :hover {
    color: #136d49 !important;
    background: #ffffff 0% 0% no-repeat padding-box !important;
  }
`
const StyledNavBarButton = styled(Button)`
  height: 40px !important;
  padding: 8px 12px !important;
  border-radius: 32px !important;
  text-transform: uppercase !important;
  color: #fff !important;
  background: #4dc11a 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #5cc11a33 !important;
  :hover {
    background: #4dc11a 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 5px 20px #4dc11a66 !important;
  }

  ${bps.down("sm")} {
    height: 36px !important;
    padding: 8px 12px !important;
  }
`

export const ActionButton = ({ title, link, ...props }: Props) => {
  return (
    <a href={link}>
      <StyledButton {...props}>
        <Typography variant="button">{title}</Typography>
      </StyledButton>
    </a>
  )
}
export const NavBarButton = ({ title, link, ...props }: Props) => {
  return (
    <a href={link}>
      <StyledNavBarButton {...props}>
        <Typography variant="button">{title}</Typography>
      </StyledNavBarButton>
    </a>
  )
}

export const InviteButton = ({ title, link, ...props }: Props) => {
  return (
    <a href={link}>
      <StyledInviteButton {...props}>
        <Typography variant="caption">{title}</Typography>
      </StyledInviteButton>
    </a>
  )
}
